import React, { useEffect, useState, useMemo } from 'react';
import { 
  Container, Table, TableHead, TableBody, TableCell, TableRow, 
  TextField, Grid, Button, Select, MenuItem, Pagination, 
  Paper, Typography, Box, Card, CardContent, Chip,
  Snackbar, Alert, CircularProgress, Dialog, DialogTitle,
  DialogContent, DialogActions, IconButton, Tooltip,
  Checkbox, FormControlLabel
} from '@mui/material';
import { Sync, Warning, CheckCircle, Error, AllInbox } from '@mui/icons-material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';

function IntegratedInventory() {  
  // Estados para Shopify
  const [shopifyInventory, setShopifyInventory] = useState([]);
  const [shopifyLoading, setShopifyLoading] = useState(false);
  const [shopifyError, setShopifyError] = useState(null);
  const [shopifySuccess, setShopifySuccess] = useState(null);

  // Estados para SAP
  const [sapInventory, setSapInventory] = useState([]);
  const [sapLoading, setSapLoading] = useState(false);
  const [sapError, setSapError] = useState(null);

  // Estados comunes
  const [filtroTexto, setFiltroTexto] = useState("");
  const [filtroTienda, setFiltroTienda] = useState(""); 
  const [filtroTipo, setFiltroTipo] = useState(""); 
  const [tiendas, setTiendas] = useState([]); 
  const [tipos, setTipos] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [syncDialogOpen, setSyncDialogOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [syncStatus, setSyncStatus] = useState({});
  const [customStockValues, setCustomStockValues] = useState({}); // Nuevo estado para valores personalizados
  
  // Nuevos estados para sincronización masiva
  const [massSyncDialogOpen, setMassSyncDialogOpen] = useState(false);
  const [massSyncSelectedItems, setMassSyncSelectedItems] = useState([]);
  const [selectAllMassSync, setSelectAllMassSync] = useState(false); 


  
  
  const rowsPerPage = 50;
  const { token, user } = useSelector(state => state.auth);

  // Configuración de Shopify - CON LOCATION ID FIJO
  const SHOPIFY_STORE =  'tienda-parma-gt.myshopify.com' //'dev-parma-store.myshopify.com';
  const SHOPIFY_GRAPHQL_URL = `https://${SHOPIFY_STORE}/admin/api/2025-04/graphql.json`;
  const ACCESS_TOKEN = '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';
  const LOCATION_ID = 'gid://shopify/Location/64171671729'; // Tu location ID

  // Función para obtener datos de Shopify
  const fetchShopifyData = async () => {
    setShopifyLoading(true);
    setShopifyError(null);
    
    try {
     const CORSPROXY_KEY = '61e41699';
    const PROXY_URL = `https://corsproxy.io/?key=${CORSPROXY_KEY}&url=`;
      let allItems = [];
      let hasNextPage = true;
      let afterCursor = null;

      while (hasNextPage) {
       const response = await fetch(PROXY_URL + encodeURIComponent(SHOPIFY_GRAPHQL_URL), {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Access-Token': ACCESS_TOKEN,
  },
  body: JSON.stringify({
    query: `query($first: Int, $after: String, $locationId: ID!) {
      inventoryItems(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            sku
            tracked
            inventoryLevel(locationId: $locationId) {
              quantities(names: ["on_hand"]) {
                quantity
              }
            }
          }
        }
      }
    }`,
    variables: { 
      first: 250, 
      after: afterCursor,
      locationId: LOCATION_ID
    }
  })
});

const raw = await response.text();

console.log('Status Shopify/proxy:', response.status);
console.log('Respuesta cruda Shopify/proxy:', raw);

if (!response.ok) {
  throw new Error(`HTTP ${response.status}: ${raw}`);
}

const data = JSON.parse(raw);

if (data.errors) {
  console.error('Error de Shopify:', data.errors);
  throw new Error(data.errors[0].message);
}
       
        
        const itemsWithInventory = data.data.inventoryItems.edges.map(edge => ({
          ...edge.node,
          shopifyQuantity: edge.node.inventoryLevel?.quantities[0]?.quantity || 0
        }));
        
        allItems = [...allItems, ...itemsWithInventory];
        hasNextPage = data.data.inventoryItems.pageInfo.hasNextPage;
        afterCursor = data.data.inventoryItems.pageInfo.endCursor;
        
        // Pequeña pausa para evitar rate limiting
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      setShopifyInventory(allItems);
      setShopifySuccess(`Obtenidos ${allItems.length} artículos de Shopify`);
      
    } catch (err) {
      setShopifyError('Error obteniendo inventario Shopify: ' + err.message);
    } finally {
      setShopifyLoading(false);
    }
  };

  // Función para obtener datos de SAP
  const fetchSapData = () => {
    setSapLoading(true);
    setSapError(null);
    
    const datos = {
      Token: "TOKEN_DE_EJEMPLO",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321"
      },
      Usr: {
        Codigo: "",
        UserNickName: user?.UserNickName || "pierril"
      },
      DatosMetodo: {
        NombreMetodo: "ListaReportesSalas",
        Datos_Recibidos: `{"Vista":"Inventarios", "Tienda":"TZ10","Tipo":"SHOPIFY"}`
      }
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`;

    fetch(fetchDataUrl)
      .then(response => response.json())
      .then(data => {
        try {
          if (data && data.datos_Generados) {
            const datosGeneradosDecodificados = JSON.parse(data.datos_Generados);

            if (Array.isArray(datosGeneradosDecodificados)) {
              const sapDataWithTotal = datosGeneradosDecodificados.map(item => ({
                ...item,
                totalSap: (item.BodegaOficial + item.BodegaInsumos + item.BodegaCocina) - (item.Factura_Pendientes || 0)
              }));
              
              setSapInventory(sapDataWithTotal);
            } else {
              setSapInventory([]);
            }
          } else {
            setSapInventory([]);
          }
        } catch (error) {
          setSapError("Error al procesar datos de SAP");
          setSapInventory([]);
        }
      })
      .catch(error => {
        setSapError("Error de conexión con SAP");
        setSapInventory([]);
      })
      .finally(() => {
        setSapLoading(false);
      });
  };

  // Match entre inventarios
  const matchedInventory = useMemo(() => {
    return sapInventory.map(sapItem => {
      const shopifyItems = shopifyInventory.filter(
        shopItem => shopItem.sku && shopItem.sku.toString() === sapItem.itemcode.toString()
      );
  
      if (shopifyItems.length === 0) {
        return {
          ...sapItem,
          shopifyItems: [],
          matchStatus: 'not_matched',
          quantityDiff: null,
          customStockValue: customStockValues[sapItem.itemcode] ?? sapItem.totalSap
        };
      }
  
      return {
        ...sapItem,
        shopifyItems,
        matchStatus: 'matched',
        shopifyQuantity: shopifyItems[0].shopifyQuantity || 0,
        quantityDiff: sapItem.totalSap - (shopifyItems[0].shopifyQuantity || 0),
        customStockValue: customStockValues[sapItem.itemcode] ?? sapItem.totalSap
      };
    });
  }, [sapInventory, shopifyInventory, customStockValues]);
  
  // 🔹 Aquí declaras matchedItemsOnly
  const matchedItemsOnly = useMemo(() => {
    return matchedInventory.filter(item => item.matchStatus === 'matched');
  }, [matchedInventory]);
  

  // Manejar cambio en el campo de stock personalizado
  const handleCustomStockChange = (itemcode, value) => {
    // Convertir a número y validar
    const numericValue = value === '' ? '' : parseInt(value, 10);
    
    if (numericValue === '' || !isNaN(numericValue)) {
      setCustomStockValues(prev => ({
        ...prev,
        [itemcode]: numericValue
      }));
    }
  };

  // Filtrar datos
  const filteredData = matchedInventory.filter(item => {
    const searchValue = filtroTexto.toLowerCase();
    return (
      (item.itemcode && item.itemcode.toString().toLowerCase().includes(searchValue)) ||
      (item.itemname && item.itemname.toLowerCase().includes(searchValue))
    );
  });

  // Paginación
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Sincronizar inventario con Shopify
 // Sincronizar inventario con Shopify - CON PROCESAMIENTO POR LOTES
// Sincronizar inventario con Shopify - CON PROCESAMIENTO POR LOTES
const syncInventoryWithShopify = async (itemsToSync) => {
  setSyncStatus({ loading: true, message: "Iniciando sincronización..." });
  console.log('Items a sincronizar:', itemsToSync);

  try {
    const CORSPROXY_KEY = '61e41699';
    const PROXY_URL = `https://corsproxy.io/?key=${CORSPROXY_KEY}&url=`;
    const BATCH_SIZE = 249; // Tamaño del lote
    const results = [];
    
    // Preparar todas las cantidades
    const allQuantities = itemsToSync.flatMap(item => 
      item.shopifyItems.map(shopifyItem => ({
        inventoryItemId: shopifyItem.id,
        locationId: LOCATION_ID,
        quantity: item.customStockValue,
        itemCode: item.itemcode // Para tracking
      }))
    );

    console.log(`Total de items a sincronizar: ${allQuantities.length}`);

    // Si no hay items válidos para sincronizar
    if (allQuantities.length === 0) {
      setSyncStatus({ 
        error: true, 
        message: "No hay items válidos para sincronizar" 
      });
      return;
    }

    // Dividir en lotes
    const batches = [];
    for (let i = 0; i < allQuantities.length; i += BATCH_SIZE) {
      batches.push(allQuantities.slice(i, i + BATCH_SIZE));
    }

    console.log(`Dividido en ${batches.length} lotes de máximo ${BATCH_SIZE} items cada uno`);

    // Procesar cada lote
    for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
      const currentBatch = batches[batchIndex];
      
      setSyncStatus({ 
        loading: true, 
        message: `Procesando lote ${batchIndex + 1} de ${batches.length} (${currentBatch.length} items)...` 
      });

      console.log(`Procesando lote ${batchIndex + 1}:`, currentBatch);

      const mutation = `
        mutation InventorySet($input: InventorySetQuantitiesInput!) {
          inventorySetQuantities(input: $input) {
            inventoryAdjustmentGroup {
              createdAt
              reason
              referenceDocumentUri
              changes {
                name
                delta
              }
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      // Preparar quantities SIN compareQuantity y con ignoreCompareQuantity: true
      const batchQuantities = currentBatch.map(q => ({
        inventoryItemId: q.inventoryItemId,
        locationId: q.locationId,
        quantity: q.quantity
        // ← SIN compareQuantity
      }));

      const variables = {
        input: {
          name: "available",
          reason: "correction",
          referenceDocumentUri: "app://parma-inventory-sync/adjustment",
          ignoreCompareQuantity: true, // ← IGNORAR COMPARACIONES
          quantities: batchQuantities
        }
      };

      console.log(`Enviando lote ${batchIndex + 1} a Shopify...`);
      
      try {
        const response = await fetch(PROXY_URL + encodeURIComponent(SHOPIFY_GRAPHQL_URL), {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Access-Token': ACCESS_TOKEN,
  },
  body: JSON.stringify({ 
    query: mutation,
    variables: variables 
  })
});

const raw = await response.text();

console.log(`Status lote ${batchIndex + 1}:`, response.status);
console.log(`Respuesta cruda lote ${batchIndex + 1}:`, raw);

if (!response.ok) {
  throw new Error(`HTTP ${response.status}: ${raw}`);
}

const result = JSON.parse(raw);

console.log(`Respuesta del lote ${batchIndex + 1}:`, result);
        
      

        if (result.errors) {
          // Error en la estructura de la query para todo el lote
          currentBatch.forEach(quantity => {
            results.push({ 
              item: quantity.itemCode,
              success: false, 
              error: result.errors[0].message,
              details: 'Error en la mutación del lote',
              batch: batchIndex + 1
            });
          });
        } else if (result.data?.inventorySetQuantities?.userErrors?.length > 0) {
          // Errores de negocio de Shopify para el lote
          result.data.inventorySetQuantities.userErrors.forEach(error => {
            results.push({ 
              success: false, 
              error: error.message,
              field: error.field,
              details: 'Error de validación Shopify en lote',
              batch: batchIndex + 1
            });
          });
          
          // Agregar éxito para los items que no tuvieron error
          const errorItemIds = result.data.inventorySetQuantities.userErrors
            .map(error => error.field)
            .filter(field => field);
            
          currentBatch.forEach(quantity => {
            if (!errorItemIds.some(errorId => quantity.inventoryItemId.includes(errorId))) {
              results.push({ 
                item: quantity.itemCode,
                success: true,
                details: 'Sincronizado exitosamente',
                batch: batchIndex + 1
              });
            }
          });
        } else if (result.data?.inventorySetQuantities?.inventoryAdjustmentGroup) {
          // Éxito - procesar cada item del lote
          currentBatch.forEach(quantity => {
            results.push({ 
              item: quantity.itemCode,
              success: true,
              details: 'Sincronizado exitosamente',
              batch: batchIndex + 1
            });
          });
        } else {
          // Respuesta inesperada para el lote
          currentBatch.forEach(quantity => {
            results.push({ 
              item: quantity.itemCode,
              success: false, 
              error: 'Respuesta inesperada de Shopify',
              details: JSON.stringify(result),
              batch: batchIndex + 1
            });
          });
        }
        
      } catch (error) {
        // Error de red o conexión para el lote
        currentBatch.forEach(quantity => {
          results.push({ 
            item: quantity.itemCode,
            success: false, 
            error: error.message,
            details: 'Error de conexión en lote',
            batch: batchIndex + 1
          });
        });
      }

      // Pequeña pausa entre lotes para evitar rate limiting
      if (batchIndex < batches.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }
    
    // Procesar resultados finales
    const successfulSyncs = results.filter(r => r.success).length;
    const failedSyncs = results.filter(r => !r.success);
    
    setSyncStatus({ 
      success: successfulSyncs > 0,
      message: `Sincronización completada: ${successfulSyncs} éxitos, ${failedSyncs.length} errores (procesado en ${batches.length} lotes)`,
      errors: failedSyncs,
      results: results
    });
    
    // Refrescar datos después de sincronizar
    setTimeout(() => {
      fetchShopifyData();
      if (failedSyncs.length === 0) {
        setSyncDialogOpen(false);
        setMassSyncDialogOpen(false);
        setSelectedItems([]); // Limpiar selección
        setMassSyncSelectedItems([]); // Limpiar selección masiva
      }
    }, 3000);
    
  } catch (error) {
    setSyncStatus({ 
      error: true, 
      message: "Error en la sincronización: " + error.message 
    });
  }
};
  // Función para manejar selección/deselección de todos los items en sincronización masiva
  const handleSelectAllMassSync = () => {
    if (selectAllMassSync) {
      setMassSyncSelectedItems([]);
    } else {
      setMassSyncSelectedItems(matchedItemsOnly.map(item => item.itemcode));
    }
    setSelectAllMassSync(!selectAllMassSync);
  };

  // Función para manejar selección individual en sincronización masiva
  const handleMassSyncItemSelect = (itemcode) => {
    if (massSyncSelectedItems.includes(itemcode)) {
      setMassSyncSelectedItems(massSyncSelectedItems.filter(code => code !== itemcode));
    } else {
      setMassSyncSelectedItems([...massSyncSelectedItems, itemcode]);
    }
  };

  // Función para abrir diálogo de sincronización masiva
  const handleOpenMassSyncDialog = () => {
    setMassSyncDialogOpen(true);
    setSelectAllMassSync(false);
    setMassSyncSelectedItems([]);
  };

  useEffect(() => {
    fetchShopifyData();
    
    // Configurar tiendas según usuario
    const userTiendas = {
      "TZ10": ["TZ10"],
      "TPRR": ["TPRR"],
      "TSCR": ["TSCR"],
      "TCSV": ["TCSV"],
      "TXLA": ["TXLA"],
      "TMIR": ["TMIR"]
    };
    
    setTiendas(userTiendas[user?.usuario] || ["TZ10", "TPRR", "TXLA", "TMIR", "TSCR", "TCSV"]);
    setTipos(["TODO", "EMPAQUE", "PRODUCTOTERMINADO", "TERCEROS"]);
  }, [user]);

  useEffect(() => {
    if (filtroTienda || filtroTipo) {
      fetchSapData();
    }
  }, [filtroTienda, filtroTipo]);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="#B3BDB5" sx={{ fontWeight: 'bold' }}>
          INVENTARIO INTEGRADO - PARMA STORE
        </Typography>
        <Box sx={{ borderBottom: 2, borderColor: 'divider', mb: 4 }} />

        {/* Alertas */}
        {shopifyError && (
          <Snackbar open autoHideDuration={6000} onClose={() => setShopifyError(null)}>
            <Alert severity="error">{shopifyError}</Alert>
          </Snackbar>
        )}
        
        {shopifySuccess && (
          <Snackbar open autoHideDuration={6000} onClose={() => setShopifySuccess(null)}>
            <Alert severity="success">{shopifySuccess}</Alert>
          </Snackbar>
        )}

        {/* Controles */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Buscar por SKU o descripción"
              variant="outlined"
              fullWidth
              value={filtroTexto}
              onChange={(e) => {
                setFiltroTexto(e.target.value);
                setCurrentPage(1);
              }}
            />
          </Grid>

        {  /*<Grid item xs={6} md={2}>
            <Select
              value={filtroTienda}
              onChange={(e) => setFiltroTienda(e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="">Todas las tiendas</MenuItem>
              {tiendas.map((tienda, index) => (
                <MenuItem key={index} value={tienda}>{tienda}</MenuItem>
              ))}
            </Select>
          </Grid> */}

       {/*
          <Grid item xs={6} md={2}>
            <Select
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="">Todos los tipos</MenuItem>
              {tipos.map((tipo, index) => (
                <MenuItem key={index} value={tipo}>{tipo}</MenuItem>
              ))}
            </Select>
          </Grid>
*/}
          <Grid item xs={12} md={6} sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              onClick={fetchShopifyData}
              disabled={shopifyLoading}
              startIcon={shopifyLoading ? <CircularProgress size={20} /> : <Sync />}
            >
              Actualizar Shopify
            </Button>
            
            <Button 
              variant="outlined" 
              onClick={fetchSapData}
              disabled={sapLoading}
            >
              Actualizar SAP
            </Button>

            <Button 
              variant="contained" 
              color="secondary"
              onClick={() => setSyncDialogOpen(true)}
              disabled={matchedInventory.length === 0}
            >
              Sincronizar
            </Button>

            <Button 
              variant="contained" 
              color="primary"
              onClick={handleOpenMassSyncDialog}
              disabled={matchedItemsOnly.length === 0}
              startIcon={<AllInbox />}
            >
              Sincronización Masiva
            </Button>
          </Grid>
        </Grid>

        {/* Información */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={6} md={3}>
            <Card sx={{ bgcolor: '#D6FFFC' }}>
              <CardContent>
                <Typography variant="h6">Shopify</Typography>
                <Typography variant="body2">
                  Items: {shopifyInventory.length} | 
                  Matched: {matchedInventory.filter(item => item.matchStatus === 'matched').length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={6} md={3}>
            <Card sx={{ bgcolor: '#D6FFE3' }}>
              <CardContent>
                <Typography variant="h6">SAP</Typography>
                <Typography variant="body2">
                  Items: {sapInventory.length} | 
                  Filtrados: {filteredData.length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Tabla */}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Estado</TableCell>
              <TableCell>Código SAP</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Stock SAP</TableCell>
              <TableCell>Stock a Sincronizar</TableCell>
              <TableCell>Stock Shopify</TableCell>
              <TableCell>Diferencia</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  {item.matchStatus === 'matched' ? (
                    <CheckCircle color="success" />
                  ) : (
                    <Error color="error" />
                  )}
                </TableCell>
                <TableCell>{item.itemcode}</TableCell>
                <TableCell>{item.itemname}</TableCell>
                <TableCell>{item.totalSap}</TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={item.customStockValue}
                    onChange={(e) => handleCustomStockChange(item.itemcode, e.target.value)}
                    size="small"
                    sx={{ width: 100 }}
                    inputProps={{ 
                      min: 0,
                      style: { 
                        backgroundColor: item.customStockValue !== item.totalSap ? '#fff3cd' : 'inherit' 
                      }
                    }}
                  />
                  {item.customStockValue !== item.totalSap && (
                    <Tooltip title="Valor modificado manualmente">
                      <IconButton 
                        size="small" 
                        onClick={() => handleCustomStockChange(item.itemcode, item.totalSap)}
                        sx={{ ml: 1 }}
                      >
                        <Sync fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
                <TableCell>
                  {item.shopifyItem ? item.shopifyItem.shopifyQuantity : 'N/A'}
                </TableCell>
                <TableCell>
                  {item.quantityDiff !== null && (
                    <Chip 
                      label={item.quantityDiff} 
                      color={item.quantityDiff === 0 ? 'default' : item.quantityDiff > 0 ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                </TableCell>
                <TableCell>
                  <Tooltip title="Seleccionar para sincronizar">
                    <IconButton
                      onClick={() => setSelectedItems(prev => 
                        prev.includes(item.itemcode) 
                          ? prev.filter(code => code !== item.itemcode)
                          : [...prev, item.itemcode]
                      )}
                      color={selectedItems.includes(item.itemcode) ? 'primary' : 'default'}
                    >
                      <Sync />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* Paginación */}
        <Pagination
          count={Math.ceil(filteredData.length / rowsPerPage)}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          sx={{ mt: 3 }}
        />

        {/* Diálogo de sincronización */}
        <Dialog open={syncDialogOpen} onClose={() => setSyncDialogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>Sincronizar Inventario</DialogTitle>
          <DialogContent>
            <Typography>
              ¿Estás seguro de que quieres sincronizar {selectedItems.length} items con Shopify?
            </Typography>
            
            {selectedItems.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Items seleccionados:</Typography>
                {matchedInventory
                  .filter(item => selectedItems.includes(item.itemcode))
                  .map(item => (
                    <Box key={item.itemcode} sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                      <Typography variant="body2">{item.itemcode} - {item.itemname}</Typography>
                      <Typography variant="body2" fontWeight="bold">
                        Stock: {item.customStockValue} 
                        {item.customStockValue !== item.totalSap && (
                          <span style={{ color: '#ff9800', fontSize: '0.8rem', marginLeft: '5px' }}>
                            (modificado)
                          </span>
                        )}
                      </Typography>
                    </Box>
                  ))
                }
              </Box>
            )}
            
            {syncStatus.loading && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <CircularProgress size={20} sx={{ mr: 2 }} />
                <Typography>Procesando...</Typography>
              </Box>
            )}
            
            {syncStatus.message && (
              <Alert 
                severity={syncStatus.error ? 'error' : syncStatus.success ? 'success' : 'info'} 
                sx={{ mt: 2 }}
              >
                {syncStatus.message}
              </Alert>
            )}
            
            {syncStatus.errors && syncStatus.errors.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Errores:</Typography>
                {syncStatus.errors.map((error, index) => (
                  <Alert key={index} severity="error" sx={{ mt: 1 }}>
                    {error.item}: {error.error}
                  </Alert>
                ))}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSyncDialogOpen(false)}>Cancelar</Button>
            <Button 
              onClick={() => syncInventoryWithShopify(
                matchedInventory.filter(item => selectedItems.includes(item.itemcode))
              )}
              disabled={syncStatus.loading}
              variant="contained"
            >
              Confirmar Sincronización
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo de sincronización masiva */}
        <Dialog open={massSyncDialogOpen} onClose={() => setMassSyncDialogOpen(false)} maxWidth="lg" fullWidth>
          <DialogTitle>Sincronización Masiva - Solo Códigos con Match</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="body1">
                Mostrando {matchedItemsOnly.length} productos con match
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAllMassSync}
                    onChange={handleSelectAllMassSync}
                    indeterminate={
                      massSyncSelectedItems.length > 0 && 
                      massSyncSelectedItems.length < matchedItemsOnly.length
                    }
                  />
                }
                label="Seleccionar todos"
              />
            </Box>

            <Box sx={{ maxHeight: '400px', overflow: 'auto' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      {/* Checkbox header - ya está manejado por FormControlLabel */}
                    </TableCell>
                    <TableCell>Código</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Stock SAP</TableCell>
                    <TableCell>Stock a Sincronizar</TableCell>
                    <TableCell>Stock Shopify</TableCell>
                    <TableCell>Diferencia</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {matchedItemsOnly.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={massSyncSelectedItems.includes(item.itemcode)}
                          onChange={() => handleMassSyncItemSelect(item.itemcode)}
                        />
                      </TableCell>
                      <TableCell>{item.itemcode}</TableCell>
                      <TableCell>{item.itemname}</TableCell>
                      <TableCell>{item.totalSap}</TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          value={item.customStockValue}
                          onChange={(e) => handleCustomStockChange(item.itemcode, e.target.value)}
                          size="small"
                          sx={{ width: 100 }}
                          inputProps={{ 
                            min: 0,
                            style: { 
                              backgroundColor: item.customStockValue !== item.totalSap ? '#fff3cd' : 'inherit' 
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {item.shopifyItem ? item.shopifyItem.shopifyQuantity : 'N/A'}
                      </TableCell>
                      <TableCell>
                        {item.quantityDiff !== null && (
                          <Chip 
                            label={item.quantityDiff} 
                            color={item.quantityDiff === 0 ? 'default' : item.quantityDiff > 0 ? 'success' : 'error'}
                            size="small"
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>

            {massSyncSelectedItems.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">
                  {massSyncSelectedItems.length} items seleccionados para sincronización
                </Typography>
              </Box>
            )}
            
            {syncStatus.loading && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <CircularProgress size={20} sx={{ mr: 2 }} />
                <Typography>Procesando...</Typography>
              </Box>
            )}
            
            {syncStatus.message && (
              <Alert 
                severity={syncStatus.error ? 'error' : syncStatus.success ? 'success' : 'info'} 
                sx={{ mt: 2 }}
              >
                {syncStatus.message}
              </Alert>
            )}
            
            {syncStatus.errors && syncStatus.errors.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Errores:</Typography>
                {syncStatus.errors.map((error, index) => (
                  <Alert key={index} severity="error" sx={{ mt: 1 }}>
                    {error.item}: {error.error}
                  </Alert>
                ))}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMassSyncDialogOpen(false)}>Cancelar</Button>
            <Button 
              onClick={() => syncInventoryWithShopify(
                matchedItemsOnly.filter(item => massSyncSelectedItems.includes(item.itemcode))
              )}
              disabled={syncStatus.loading || massSyncSelectedItems.length === 0}
              variant="contained"
              color="primary"
            >
              Sincronizar {massSyncSelectedItems.length} Items
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  );
}

export default IntegratedInventory;